import $ from 'gridstrap/lib/gs-zepto';

export class GSTestimonialCarousel {

	//
	// Properties
	//

	private root;
	private items;

	get allItems() { return this.items.find('.gs-TestimonialCarousel-item'); }
	get activeItem() { return this.allItems.first(); }

	//
	// Methods
	//

	next() {
		this.activeItem
			.addClass('is-prev')
			.one('transitionend', () => {
				this.activeItem.appendTo(this.items);
				this.allItems.removeClass('is-prev');
				this.queue();
			});
	}

	queue() {
		let delay = this.activeItem.gs(0).readingTime;
		setTimeout(() => this.next(), delay);
	}

	//
	// Initializations & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.items = this.root.find('.gs-TestimonialCarousel-items');
		this.items.css('width', `${this.allItems.length * 100}%`);
	}

	gsOnInit() {
		this.queue();
	}

}
